// Port de app/(tabs)/suporte.tsx.
//
// WEB: no nativo esta aba abria o WhatsApp (Linking.openURL) com DADOS FIXOS de uma pessoa
// (nome/matrícula/ID de teste) e era inalcançável — BottomBar e atalho da Home já desviam
// para /suporte-chat. Aqui ela só redireciona para o chat de suporte (docs/port/04 §1.2, Q5),
// sem montar o link do WhatsApp nem expor aqueles dados.
import { Redirect } from "@/navigation";

export default function Suporte() {
  return <Redirect href="/suporte-chat" />;
}
